import ContentManagementPage from '../../ContentManagement/ContentManagementPage';

const ServiceContentManagementWithParamsPage = () => (
  <ContentManagementPage mode="serviceWithParams" />
);

export default ServiceContentManagementWithParamsPage;
